webpackJsonp([114939829339817],{

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Block = __webpack_require__(22);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tip = function Tip(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _Block2.default,
	    { tint: 120, icon: 'lightbulb', header: 'Tip' },
	    children
	  );
	};
	
	exports.default = Tip;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(10);
	
	var _Command = __webpack_require__(32);
	
	var _Command2 = _interopRequireDefault(_Command);
	
	var _Heading = __webpack_require__(27);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _P = __webpack_require__(23);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _SH = __webpack_require__(28);
	
	var _SH2 = _interopRequireDefault(_SH);
	
	var _Theory = __webpack_require__(33);
	
	var _Theory2 = _interopRequireDefault(_Theory);
	
	var _Tip = __webpack_require__(58);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _Toc = __webpack_require__(34);
	
	var _Toc2 = _interopRequireDefault(_Toc);
	
	var _ButtonLink = __webpack_require__(26);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-useless-escape */
	/* eslint-disable import/no-webpack-loader-syntax */
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Toc2.default, { active: 'encore' }),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 7 },
	      'Webpack Encore'
	    ),
	    _react2.default.createElement(
	      _Theory2.default,
	      null,
	      _react2.default.createElement(
	        _P2.default,
	        null,
	        'Let\'s talk about Webpack Encore.'
	      )
	    ),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 5 },
	      'A Symfony Project'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Create a new Symfony Project with:'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'composer create-project symfony/website-skeleton sfreact'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Let\'s add a first controller in',
	      ' ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'src/Controller/SecretAgentController.php'
	      ),
	      ' with this code:'
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'PHP',
	      code: '\n<?php\n\nnamespace AppController;\n\nuse SymfonyComponentHttpFoundationResponse;\n\nclass SecretAgentController\n{\n    public function code()\n    {\n        return new Response(\n            \'<html><body>Agent code: 007</body></html>\'\n        );\n    }\n}\n'
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Note that we aren\'t doing anything with JavaScript yet.'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Now, activate your route adding this code to',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'config/routes.yml'
	      )
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'yaml',
	      code: '\nsecret-agent:\n    path: /secret-agent\n    controller: AppControllerSecretAgentController::code\n    '
	    }),
	    _react2.default.createElement(
	      _Tip2.default,
	      null,
	      'Careful, don\'t add your routes to',
	      ' ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'config/packages/routing.yaml'
	      ),
	      '. That file contains the configuration of the routing package, not the definition of routes.'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'And run the server:'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'php -S 127.0.0.1:8080 -t public'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Open in your browser',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'http://localhost:8080/secret-agent'
	      ),
	      'To verify that your Symfony installation is working before adding more pieces to it.'
	    ),
	    _react2.default.createElement(
	      _Heading2.default,
	      { fontSize: 5 },
	      'Webpack Encore'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Let\'s install Encore and PhpExecJs'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'composer require webpack-encore'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'composer require nacmartin/phpexecjs'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'npm install'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'npm install --save left-pad'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'And write an encore config in ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'webpack.config.ssr.js'
	      )
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'javascript',
	      code: '\nvar Encore = require("@symfony/webpack-encore");\n\nEncore.setOutputPath("var/webpack/")\n  .setPublicPath("/")\n  .addEntry("server-bundle", "./assets/js/app.js");\n\nmodule.exports = Encore.getWebpackConfig();\n'
	    }),
	    _react2.default.createElement(
	      _Tip2.default,
	      null,
	      'You will see that there is already a ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'webpack.config.js'
	      ),
	      ' ',
	      'already. Don\'t touch it for now. It makes sense to have two different Webpack configurations for the JS code that will be run in your client and in your server.'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'And place the code we stole to the MI6 unto into',
	      ' ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'assets/js/app.js'
	      )
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'javascript',
	      code: '\nimport leftPad from "left-pad";\n\nvar sum = (a, b) => a + b;\n\nvar makeSecretAgent = code => leftPad(code, 3, 0);\n\nvar sumSecretAgent = (a, b) => makeSecretAgent(sum(a, b));\n\nglobal.sumSecretAgent = sumSecretAgent;\n'
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Note that this is not the pipeline version. It would be possible to use pipeline in encore, but let\'s be conservative.'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Let\'s try to generate a SSR bundle with Encore:'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Run:'
	    ),
	    _react2.default.createElement(
	      _Command2.default,
	      null,
	      'npx encore dev --config webpack.config.ssr.js --watch'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'And verify that a file ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'var/webpack/server-bundle.js'
	      ),
	      ' has been created.'
	    ),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Let\'s adapt our controller to use this JS code:'
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'PHP',
	      code: '\n<?php\n\nnamespace AppController;\n\nuse SymfonyComponentHttpFoundationResponse;\nuse NacmartinPhpExecJsPhpExecJs;\n\nclass SecretAgentController\n{\n    public function code($ssrBundleLocation)\n    {\n\n        $phpexecjs = new PhpExecJs();\n\n        $phpexecjs->createContextFromFile($ssrBundleLocation);\n\n        $variant = "sumSecretAgent(3, 4);";\n\n        $result = $phpexecjs->evalJs($variant);\n\n        return new Response(\n            \'<html><body>Agent code: \'.$result.\'</body></html>\'\n        );\n    }\n}'
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'Since we are ',
	      _react2.default.createElement(
	        'i',
	        null,
	        'injecting'
	      ),
	      ' the parameter',
	      ' ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        '$ssrBundleLocation'
	      ),
	      ' we need to define what it means in',
	      ' ',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'config/services.yml'
	      )
	    ),
	    _react2.default.createElement(_SH2.default, {
	      language: 'yaml',
	      code: '\nservices:\n  _defaults:\n    #...\n    bind:\n      $ssrBundleLocation: "%kernel.project_dir%/var/webpack/server-bundle.js"'
	    }),
	    _react2.default.createElement(
	      _P2.default,
	      null,
	      'With you we should be ready to open',
	      _react2.default.createElement(
	        _rebass.Code,
	        null,
	        'http://localhost:8080/secret-agent'
	      ),
	      'and have all the pieces working together.'
	    ),
	    _react2.default.createElement(_ButtonLink2.default, { to: '/react', title: 'Go to the next section' })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-encore-js-a3b34a3de95071a62d09.js